import { ContactsOutlined } from '@ant-design/icons';
import type { NavigationItemType } from '~/types/navigation';

export default {
    id: 'suppliers',
    title: 'Dobavljači',
    icon: ContactsOutlined,
    type: 'item',
    url: '/suppliers',
} satisfies NavigationItemType;
